import React, { Component } from "react";
import styles from "./styles";
import * as images from "./images";

export default class ForbiddenView extends Component {
  render() {
    return (
      <div style={styles.wrapper}>
        <div>
          <img src={images.mascote} alt="" />
          <h2>
            <strong>Oops!</strong> Parece que você não pode acessar essa página.
          </h2>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/forbidden/view.jsx